<style>
.form_container .el-input {
  width: 233px;
}
.member-new-button {
  margin-top: 55px;
  text-align: center;
}
.member-new-button .el-button {
  width: 230px;
  padding: 14px 0;
  font-size: 16px;
  background-color: #ffb03e;
  border-color: #ffb03e;
  color: #fff;
}
</style>

<template lang="pug">
el-card
  el-form.form_container(:model="form" ref="form" label-width="110px")
    el-form-item(prop="old_password" verify label="原密码：")
      el-input(v-model.trim="form.old_password" type="password" placeholder='请输入原密码' size="small")
    el-form-item(prop="new_password" verify label="新密码：")
      el-input(v-model.trim="form.new_password" type="password" placeholder='请输入新密码' size="small")
    el-form-item(prop="true_password" verify :verify="verifyPassword" label="确认密码：")
      el-input(v-model.trim="form.true_password" type="password"  placeholder='请再次输入新密码' size="small")
  .member-new-button
    ElButton(round @click="submit") 保存
</template>

<script>
export default {
  data() {
    return {
      form: {
        old_password: '',
        new_password: '',
        true_password: ''
      }
    };
  },
  methods: {
    verifyPassword(rule, val, callback) {
      if (val !== this.form.new_password) {
        callback(Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.resetPassword();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    resetPassword() {
      const {old_password, new_password, true_password} = this.form;
      this.$http
        .post('/api/shop/store/upPassword', {
          old_password,
          new_password,
          true_password
        })
        .then(_ => {
          this.$toast('修改成功');
        })
        .catch(error => {
          this.$toast(error);
        });
    }
  }
};
</script>
